import { ErrorName } from 'src/constants';

import { BaseError } from './BaseError';

export class FilenameExceededError extends BaseError {
  constructor({ maximum, actual }: { maximum: number; actual: number }) {
    super(
      `Maximum allowed filename length is ${maximum} characters. Received ${actual} characters. Please rename the file and try to upload it again.`,
      {
        name: ErrorName.FilenameExceededError,
      },
    );
  }
}
